import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, allowedRoles }) => {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div style={{
                display: 'flex', flexDirection: 'column', alignItems: 'center',
                justifyContent: 'center', minHeight: '100vh', gap: 16,
            }}>
                <div style={{
                    width: 40, height: 40, border: '4px solid #e2e8f0',
                    borderTopColor: '#059669', borderRadius: '50%',
                    animation: 'spin 0.8s linear infinite',
                }} />
                <p style={{ fontSize: 14, color: '#64748b', fontFamily: 'Outfit, sans-serif' }}>Loading...</p>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (allowedRoles && !allowedRoles.includes(user.role)) {
        const dashboardPaths = {
            admin: '/admin/dashboard',
            teacher: '/teacher/dashboard',
            student: '/student/dashboard'
        };
        return <Navigate to={dashboardPaths[user.role] || '/login'} replace />;
    }

    return children;
};

export default ProtectedRoute;
